import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SNModalService } from '@web-services/modal/snModal.service';
import { createNumberMask } from 'text-mask-addons/dist/textMaskAddons';
import { MessageService } from '@services/helpers/message-service/message.service';
import { IModalAction, IProductPackageItem } from '@models/models';
import { ProductPackageService } from '@web-services/settings/productPackage.service';

@Component({
	selector: 'update-discount-modal',
	template: require('./update-discount-modal.component.html'),
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateDiscountModal implements OnInit {
	@Input() modalAction: string;
	@Input() modalData: IProductPackageItem;
	@Input() btnDisabled: boolean;
	numberMask: any;
	currencySymbol: string;

	constructor(
		public activeModal: NgbActiveModal,
		private modalService: SNModalService,
		private productPackageService: ProductPackageService,
		private messageService: MessageService
	) {}

	ngOnInit(): void {
		this.currencySymbol = this.productPackageService.getCurrensySymbol();
		this.numberMask = createNumberMask({
			prefix: `-${this.currencySymbol}`,
			suffix: '',
			allowDecimal: true,
			allowLeadingZeroes: true,
			allowNegative: false
		});
	}

	onSubmit(): void {
		if (this.validateModalValue()) {
			const dataToEmit = this.prepareValueToEmit();
			this.modalService.setModalData(dataToEmit);
		}
	}

	validateModalValue(): boolean {
		let validated = true;
		let { name, price } = this.modalData;

		name = name.trim();

		if (!name || name === '') {
			validated = false;
			this.messageService.showToaster('e_0', 'productsPackages', 'discount');
		} else if (!price || price === '') {
			validated = false;
			this.messageService.showToaster('e_2', 'productsPackages', 'discount');
		}

		return validated;
	}

	prepareValueToEmit(): IModalAction<IProductPackageItem> {
		const modalData = JSON.parse(JSON.stringify(this.modalData));
		modalData.price = this.convertAmountIntoNumber(modalData.price);
		modalData.name = modalData.name.trim();

		return {
			action: this.modalAction,
			props: modalData
		};
	}

	convertAmountIntoNumber(value: any): number {
		if (isNaN(value)) {
			const regExp = new RegExp(`[${this.currencySymbol},]`, 'g');
			const a = value.replace(regExp, '');
			return +a;
		}

		return +value;
	}

	onDismiss(): void {
		this.activeModal.dismiss();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/packages-product/modals/update-discount-modal/update-discount-modal.component.ts